import ajaxService from './ajaxService';

export default {
  // 取得Coupon資料
  getPrizeCustomizeCoupon(params, headers) {
    try {
      const queryString = new URLSearchParams(params).toString();
      return ajaxService.post(`/pmt/get/api/v1/prize/customize-coupon?${queryString}`, {}, headers);
    } catch (err) {
      return err.response;
    }
  },
  // 取得Coupon
  async getCoupon(params) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const res = await ajaxService.post(`/pmt/get/api/v1/prize/customize-coupon?${queryString}`);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  async postCustomizeCouponActivity(body) {
    try {
      const res = await ajaxService.post('/pmt/post/api/v1/customize-coupon/activity', body);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
};
